import { useEffect, useState } from 'react';
import { useChannelStateContext } from 'stream-chat-react';

import { useChatClient } from '@bizzabo/chat-core';
import { useErrorHandler } from 'react-error-boundary';

const useIsGuestOnline = () => {
    const { client } = useChatClient();
    const handleError = useErrorHandler();
    const { channel } = useChannelStateContext();
    const [isGuestOnline, setIsGuestOnline] = useState(false);

    useEffect(() => {
        const watchChannel = async () => {
            try {
                const state = await channel.watch({ presence: true });
                const guestsList = Object.values(state.members).filter(
                    ({ user }) => user.id !== client.userID
                );
                const isGuestOnline = guestsList?.[0]?.user.online;
                setIsGuestOnline(isGuestOnline);
            } catch (error) {
                handleError(error);
            }
        };

        watchChannel();

        const clientListener = client.on('user.presence.changed', event => {
            setIsGuestOnline(event.user.online);
        });

        return () => {
            clientListener.unsubscribe();
        };
    }, [channel, client]);

    return isGuestOnline;
};

export default useIsGuestOnline;
